module.exports = __webpack_public_path__ + "img/U1F399.a8b3f8ee.png";